import React from "react";
import { VideoDataProvider } from "./VideoDataProvider";

export const VodDataProvider = props => {
  return <VideoDataProvider {...props} />;
};
